function initBenefitTagDragScroll(el) {
  if (el.dataset.dragScrollInit === 'true') return;
  el.dataset.dragScrollInit = 'true';

  const state = {
    isDown: false,
    startX: 0,
    startScrollLeft: 0,
    moved: false
  };

  const endDrag = () => {
    state.isDown = false;
    el.classList.remove('is-grabbing', 'is-dragging');
  };

  el.addEventListener('pointerdown', (evt) => {
    if (evt.pointerType !== 'mouse' || evt.button !== 0) return;
    state.isDown = true;
    state.moved = false;
    state.startX = evt.clientX;
    state.startScrollLeft = el.scrollLeft;
    el.classList.add('is-grabbing');
    if (typeof el.setPointerCapture === 'function') {
      try {
        el.setPointerCapture(evt.pointerId);
      } catch (e) {}
    }
  });

  el.addEventListener('pointermove', (evt) => {
    if (!state.isDown || evt.pointerType !== 'mouse') return;
    const dx = evt.clientX - state.startX;
    if (Math.abs(dx) < 2) return;

    state.moved = true;
    evt.preventDefault();
    el.classList.add('is-dragging');
    el.scrollLeft = state.startScrollLeft - dx;
  });

  el.addEventListener('pointerup', endDrag);
  el.addEventListener('pointercancel', endDrag);
  el.addEventListener('lostpointercapture', endDrag);

  el.addEventListener('dragstart', (evt) => evt.preventDefault());

  el.addEventListener('click', (evt) => {
    if (!state.moved) return;
    evt.preventDefault();
    evt.stopPropagation();
    state.moved = false;
  }, true);
}

function initAllBenefitTagScroll(root = document) {
  root.querySelectorAll('.product-block__benefit-tags:not([data-drag-scroll-init])').forEach(initBenefitTagDragScroll);
}

// Custom add to cart form handler for product blocks
document.addEventListener('DOMContentLoaded', () => {
  initAllBenefitTagScroll();

  const benefitTagObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.matches?.('.product-block__benefit-tags')) {
          initBenefitTagDragScroll(node);
        }
        initAllBenefitTagScroll(node);
      });
    });
  });
  benefitTagObserver.observe(document.body, { childList: true, subtree: true });

  theme.addDelegateEventListener(document, 'submit', '.custom-add-to-cart-form', async (evt, form) => {
    evt.preventDefault();

    const submitBtn = form.querySelector('button[type="submit"]');
    submitBtn.setAttribute('aria-disabled', 'true');
    submitBtn.classList.add('is-loading');

    const formData = new FormData(form);

    try {
      const response = await fetch('/cart/add', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      const data = await response.json();

      if (response.ok) {
        // Dispatch cart change event
        document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));

        // Open cart drawer
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
      } else {
        // Handle error
        console.error('Add to cart error:', data);
      }
    } catch (error) {
      console.error('Add to cart failed:', error);
    } finally {
      submitBtn.classList.remove('is-loading');
      submitBtn.removeAttribute('aria-disabled');
    }
  });
});